export const painSliderCopyEnUs = {
    scoringHint:
        "Go with your first thought - pick the number that matches how you feel right now. No need to overthink it.",
};
